import { IconCheck } from '@tabler/icons-react'
import styled from 'styled-components'

import { theme } from '../../../styles/theme'

type CheckIconProps = {
	isChecked: boolean
}

export const CheckIcon = styled(IconCheck).attrs({
	size: 16,
	stroke: 3,
})<CheckIconProps>`
	position: absolute;
	top: 2px;
	left: 2px;
	color: ${theme.color.input.background};
	opacity: ${({ isChecked }) => (isChecked ? 1 : 0)};
	transition: opacity 150ms ease-in-out;
`
